import { RECO_SHARE_ROUTE, RECOMMENDATION_ROUTE } from '@/constants/routes';

/** The 🎵 reco flow: the centre button stays lit on each of its screens. */
const RECO_FLOW: string[] = [RECOMMENDATION_ROUTE, RECO_SHARE_ROUTE];

export const isRecoFlow = (pathname: string) => RECO_FLOW.includes(pathname);
